/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "@/components/pages/partners/styles.module.css";
import { useTranslations } from "next-intl";
import ButtonComponent from "@/components/button";
import NewDistributorModal from "@/components/pages/branches/whereToBuy/newDistributorModal";
import { useModalsStore } from "@/providers/store/modalsStoreProvider";
import routes from "@/configs/routes";
import { ArrowUpRight } from "__barrel_optimize__?names=ArrowUpRight!=!lucide-react";
import { cn } from "@/utils/theme/cn";
export default function Button(param) {
    let { withWhereToBuy, partnersPage } = param;
    // hooks
    const T = useTranslations();
    const toggleModal = useModalsStore((state)=>state.toggleModal);
    // constants
    const partnerHandler = ()=>{
        toggleModal({
            id: 'one',
            component: /*#__PURE__*/ _jsx(NewDistributorModal, {}),
            title: 'becoming_a_partner',
            description: 'BECOME_PARTNER_DESCRIPTION',
            className: 'w-200'
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.how,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.howTitle,
                children: T('how_to_join')
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.howDescription,
                children: T('PARTNER_HOW_TO_JOIN')
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.buttons,
                children: [
                    /*#__PURE__*/ _jsxs(ButtonComponent, {
                        rounded: true,
                        ...partnersPage ? {
                            onClick: partnerHandler
                        } : {
                            link: routes.partners
                        },
                        className: cn(styles.button, 'text-primary! dark:bg-layout-background!'),
                        children: [
                            T(partnersPage ? 'becoming_a_partner' : 'interested_in_becoming_a_partner'),
                            /*#__PURE__*/ _jsx(ArrowUpRight, {
                                size: 22
                            })
                        ]
                    }),
                    withWhereToBuy && /*#__PURE__*/ _jsxs(ButtonComponent, {
                        rounded: true,
                        link: routes.whereToBuy,
                        className: cn(styles.button, 'bg-transparent! shadow-none!'),
                        children: [
                            T('where_to_buy'),
                            /*#__PURE__*/ _jsx(ArrowUpRight, {
                                size: 22
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
